function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M80,122a10,10,0,1,1-10-10A10,10,0,0,1,80,122Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M135.38,233.14A119.29,119.29,0,0,1,83.2,159.56a10,10,0,1,0-19.47,4.58h0A139.22,139.22,0,0,0,124.62,250a10,10,0,1,0,10.76-16.86Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M483.92,46A61,61,0,0,0,438.8,26H380V10A10,10,0,0,0,370,0H30A10,10,0,0,0,20,10V132A179.72,179.72,0,0,0,86.86,272H10a10,10,0,0,0,0,20,13.39,13.39,0,0,1,12.79,9.61A70.32,70.32,0,0,0,90,352H330a70.32,70.32,0,0,0,67.21-50.39A13.39,13.39,0,0,1,410,292a10,10,0,0,0,0-20H313.16a181,181,0,0,0,21.29-20.33c3.28.19,6.54.29,9.76.29,40.12,0,75.73-14.64,103.68-42.81,28.57-28.8,46.85-70.08,51.47-116.24A61,61,0,0,0,483.92,46ZM380,86h58.8a.63.63,0,0,1,.61.25.66.66,0,0,1,.24.68c-2.71,27.1-14.84,87.48-68.81,101.88A178.92,178.92,0,0,0,380,132Zm-2,210a50.25,50.25,0,0,1-48,36H90a50.23,50.23,0,0,1-48-36,33.56,33.56,0,0,0-1.46-4H379.47A32,32,0,0,0,378,296ZM122.52,272A159.88,159.88,0,0,1,40,132V20H360V132a159.93,159.93,0,0,1-82.5,140ZM479.46,90.93C472.64,159,429.34,228.77,349.77,231.84a180.36,180.36,0,0,0,12-20.91c28.15-3.69,51.86-17.49,68.84-40.15,15.65-20.86,25.64-49.16,28.91-81.84a20.83,20.83,0,0,0-18.61-22.83c-.7-.07-1.41-.11-2.11-.11H380V46h58.8a40.87,40.87,0,0,1,40.86,40.88c0,1.35-.07,2.7-.2,4.05Z"
});

function SvgCup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 499.66 352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M410,282a23.32,23.32,0,0,0-22.39,16.81A60,60,0,0,1,330,342H90a60,60,0,0,1-57.61-43.19A23.32,23.32,0,0,0,10,282Z",
    style: {
      fill: "#c41d7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.8,36H370V10H30V132a170,170,0,0,0,89.93,150H280.07a171,171,0,0,0,50.11-40.66c91.32,8,150.56-62.79,159.23-149.42a50.87,50.87,0,0,0-45.55-55.67A50.27,50.27,0,0,0,438.8,36Zm10.8,51.93c-5.82,58.19-34.58,108.86-94.45,113.65A169.42,169.42,0,0,0,370,132V76h68.8a10.82,10.82,0,0,1,10.86,10.78A10.93,10.93,0,0,1,449.6,87.93Z",
    style: {
      fill: "#edd1e8"
    }
  }), _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.eec2322e.svg";
export { ForwardRef as ReactComponent };